<style lang="scss" scoped>
  .act-media {
    border-bottom: 1px solid #eae6f0;
    padding: 18px 0 18px;

    a {
      padding-left: 30px;
    }

    &:first-child {
      padding: 0 0 18px;
    }
  }

  .act-media,
  .act-media-body {
    overflow: inherit;
  }

  .btn-group .btn-box-success {
    border: none;
  }

  .btn-group .btn-box-success:not(.active) {
    color: #555;

    &:hover {
      color: #fff;
    }
  }

  .act-media-body {
    color: #333;

    .type {
      font-size: 10px;
      color: #857a98;
      font-weight: 400;
    }

    strong {
      color: #3b334a;
      font-size: 12px;
      font-weight: 700;
      letter-spacing: -0.18px;
    }

    .activity-content p {
      color: #3b334a;
      font-size: 13px;
      font-weight: 400;
    }
  }

  .activity-list {
    .small {
      display: inline !important;
    }

    .completed {
      text-decoration: line-through;
    }

    .delayed {
      color: #f31357;
      font-size: 10px;
      font-weight: 400;
      letter-spacing: -0.15px;
    }
  }
</style>

<template>
  <div>
    <div class="profile-card-header">
      <h4>{{ __('Histórico de atividades') }}</h4>
      <i
        class="fa fa-circle-o-notch fa-spin float-right"
        v-if="activities.length && loading"
      />
    </div>
    <div
      class=""
      v-if="activities.length && ! loading"
    >
      <div class="activity-list">
        <div
          class="media act-media"
          v-for="activity in activities"
          :key="activity.id"
        >
          <a
            class="float-left"
            href="#"
          >
            <Avatar
              width="36"
              class="media-object act-thumb circle m-t-5"
              :name="activity.lead.name || activity.lead.email"
              :url="activity.lead.gravatar"
            />
          </a>
          <div class="media-body act-media-body ml-2">
            <div class="pt-2">
              <label>
                <strong>{{ activity.lead.name || activity.lead.email }}</strong>
                <span class="type ml-2"><i :class="activity.type.icon" /> {{ activity.type.name }}</span>
              </label>
            </div>
            <div
              class="activity-content form-group"
              v-html="format(activity.content)"
            />

            <LeadActivityData
              v-if="activity.data"
              :activity="activity"
            />

            <span class="small">
              <span
                class="type"
                v-b-tooltip.left="formatDate(activity.created_at)"
              >
                {{ activity.created_at | ago }}
              </span>
            </span>
            <span
              class="small m-l-5"
              v-if="activity.deal"
            >
              <a
                :href="'/deal#/' + activity.deal.hashid"
                target="_blank"
              >
                Negócio #{{ activity.deal.id }}
              </a>
            </span>
            <small class="pl-2">
              <span
                :class="{ completed: activity.completed_at, delayed: isDelayed(activity) }"
                v-if="activity.scheduled_at"
              >
                Prazo: {{ activity.scheduled_at | datetime('DD/MM/YY HH:mm') }}
                <i
                  class="fa fa-exclamation-triangle delayed"
                  v-b-tooltip="'Atraso'"
                  v-if="isDelayed(activity)"
                />
              </span>
            </small>
          </div>
        </div>
      </div>
    </div>
    <div
      class="card-body"
      v-else-if="loading"
    >
      <i class="fa fa-circle-o-notch fa-spin" />
    </div>
    <div
      class="row no-activity"
      v-else
    >
      <div class="col-5 mt-4">
        <span class="fs-13 light-gray">{{ __('Você ainda não tem nenhuma atividade') }}</span>
      </div>
      <img
        class="ml-5"
        src="/build/icons/no-data.svg"
        height="87px"
      >
    </div>
  </div>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue';
import dayjs from '../../core/dayjs';

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },

  props: {
    activities: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },

  created () {
    this.load();
  },

  methods: {
    load () {
      this.$emit('toggle', this.current);
    },

    isDelayed (activity) {
      const delayed = activity
          && activity.scheduled_at
          && ! activity.completed_at
          && new Date().getTime() > new Date(activity.scheduled_at).getTime();

      return delayed;
    },

    mentions (str) {
      return str.replace(/"(\w+)">(@\w[ \w]*)</g, '"$1"><a href="/user/$1/profile">$2</a><')
        .replace(/(@\w[ \w]*)#(\w+)/g, '<a href="/user/$2/profile" class="mention">$1</a>');
    },

    format (str) {
      return this.mentions(str.replace(/<p><\/p>/g, '<p><br></p>'));
    },

    formatDate (date) {
      return dayjs(date).format('LDT');
    },
  },
};
</script>
